module.exports = "<packages-native-component\n        host-data=\"$ctrl.hostData\"\n        disabled-package-types=\"$ctrl.disabledPackageTypes\"\n        id=\"package-native-component\">\n</packages-native-component>"


//////////////////
// WEBPACK FOOTER
// ./states/package_native/native.view.html
// module id = 375
// module chunks = 5